import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const _createFetchParams = issueId => ({
    id: issueId
});

const
    name = 'serviceNowWritePermissions',
    exports = {
        createFetchParams: _createFetchParams,
        ...storeModuleFactory({
            name,
            timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
            endpoint:           endpoints.serviceNow.writePermissionsIncidentEndpoint,
            transformResultsFn: json => ({
                id:               json.id,
                writePermissions: json.write_permissions
            })
        })
    };

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/serviceNowWritePermissions.js